import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { colors } from 'utils/styles/theme';

interface ItemWrapperProps {
  isMobile?: boolean;
  textColor?: string;
  backgroundColor: string;
  defaultBlackHeading: boolean;
}

interface ImageOverlayProps {
  backgroundColor: string;
}

const hoverImage = (
  backgroundColor: ItemWrapperProps['backgroundColor'],
  textColor: Required<ItemWrapperProps['textColor']>,
  defaultBlackHeading: ItemWrapperProps['defaultBlackHeading']
) => css`
  &::after {
    content: attr(data-title);
    position: absolute;
    inset: 0;
    padding: 12px;
    ${textColor && `color: ${textColor}`};
    ${defaultBlackHeading && `color: ${colors.black}`};
    ${({ theme: { locale } }) => setTypography('filter', locale)};
    transition: color 0.4s ease-in-out;
    pointer-events: none;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: ${backgroundColor};
    opacity: 0;
    transition: opacity 0.4s ease-in-out;
    pointer-events: none;
  }

  &:hover {
    &::before {
      opacity: 0.5;
    }
    &::after {
      ${defaultBlackHeading && `color: ${textColor || colors.white}`};
    }
  }
`;

export const ItemWrapper = styled(motion.li)<ItemWrapperProps>`
  display: flex;

  position: relative;
  overflow: hidden;

  ${({ isMobile, backgroundColor, textColor, defaultBlackHeading }) =>
    !isMobile &&
    backgroundColor &&
    hoverImage(backgroundColor, textColor, defaultBlackHeading)};

  cursor: pointer;
`;

export const ImageOverlay = styled(motion.div)<ImageOverlayProps>`
  position: absolute;
  inset: 0;

  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: 12px;
`;
